module.exports = __webpack_public_path__ + "static/img/pochan.6160b9a7.png";